export default {
    init() {
        /* eslint-disable */

        // JavaScript to be fired on all pages
        
        /* OLD JS */

        (function($) {

            // DOM Ready
            $(document).ready( function () {

              if (jQuery('#viewport')) {
                jQuery('#viewport').html(jQuery(window).width() + ' x ' + jQuery(window).height());
                jQuery(window).resize(function(){
                  jQuery('#viewport').html(jQuery(window).width() + ' x ' + jQuery(window).height());
                });
              }

              // if about page loaded with hash anchor, scroll to position so that anchor is visible at top (below header)
              // this will override the previous highlight
              var hash = window.location.hash.replace('#', '');
              if (hash != '') {
                jQuery('html, body').scrollTop(0);
                jQuery('html, body').animate({ scrollTop: jQuery('#' + hash).offset().top - 195}, 750);
                // and move the pointer
                jQuery('.subnav ul.menu li').removeClass('current-menu-item');
                jQuery('.subnav ul.menu li').each(function(){
                  if (jQuery(this).attr('id') == hash) {
                    jQuery(this).addClass('current-menu-item');
                  }
                });
              }
              

              // if user clicks about page sidebar, scroll to the clicked anchor
              jQuery('body.page-template-page-about-php .subnav a').click(function(){
                // do the scroll
                chosenid = jQuery(this).attr('href').substring(1);
                // where are we going
                newtop = jQuery('#' + chosenid).offset().top - 195;
                // if first section, force absolute top
                if (jQuery('div.page').first().attr('id') == chosenid) {
                  newtop = 0;
                }
                // and scroll it
                jQuery('html, body').animate({ scrollTop: newtop}, 750);
                // and move the pointer
                jQuery(this).closest('ul').children('li').removeClass('current-menu-item');
                jQuery(this).closest('li').addClass('current-menu-item');
                return false;
              });

              
              // if user scrolls about page, add current-menu-item class to correct sidebar li
              if(window.location.pathname == '/about-us/') {
                jQuery(window).bind('scrollstop', function(e){
                  ourid = '';
                  scrolltop = jQuery(window).scrollTop() + 195; // allow for top panel
                  var done = false;
                  jQuery('div.page').each(function(){
                    divid = jQuery(this).attr('id');  
                    divtop = jQuery(this).offset().top;
                    if (!done) {
                      // not found a div yet
                      if (scrolltop <= divtop) {
                        // scrolltop is above first divtop
                        ourid = divid;
                        done = true;
                      }
                    }
                    // as we scroll down, divtops of each div remain the same, scrolltop increases
                    // as scrolltop increases past each divtop, that's the one.
                    // so, the LAST divtop that is smaller than scrolltop is the one.
                    if (!done) { if (scrolltop > (divtop)) ourid = divid; }
                  });
                  if (ourid == '') ourid = jQuery('div.page').first().attr('id');
                  // override for last panel in case it's not as high as the window
                  if(jQuery(window).scrollTop() + jQuery(window).height() >= jQuery(document).height() - 10) ourid = divid;
                  // now get the right menu item
                  jQuery('.subnav ul.menu li').removeClass('current-menu-item');
                  jQuery('.subnav ul.menu li').each(function(){
                    if (jQuery(this).find('a').attr('href') == '#' + ourid) {
                      jQuery(this).addClass('current-menu-item');
                      return false; // break out of the each
                    }
                  });
                });
              }

              if ( $.fn.masonry ) {

                $('body').imagesLoaded( function() {
                    
                  $('.masonry-grid').masonry({
                    itemSelector: '.grid-item'
                  });

                });
              }

              /* Mega Menu */
              $('.mega-menu a').on('click', function(e) {
                if(window.innerWidth <= 767 ) {
                  e.preventDefault();
                  $(this).parent('li').toggleClass('open');
                  var $submenu = $(this).next('.sub-menu');
                  
                  $submenu.slideToggle();

                }
              });

              $(window).resize(function() {
                if(window.innerWidth >= 767 ) {
                  $('.mega-menu.open').removeClass('open');
                  $('.sub-menu').css('display', '');
                }
              });

              $('#newsletter_form').on('submit', function(e) {
                e.preventDefault();

                var $form = $(this);
                var $response = $form.find('.form-response');
                var input = $(this).find('input[type=email]');
                $response.slideUp();

                var data = {
                  'action': 'newsletter_signup',
                  'ajax_nonce': GE.ajax.nonce,
                  'email': input.val()
                };

                $.post( GE.ajax.url, data, function(res) {
                  console.log(res);
                  if(res.success) {
                    input.val('');
                    $response.html(res.message).slideDown();
                  } else {
                    $response.html(res.message).slideDown();
                  }
                });

              });



              // Add custom class to the current one
              /*$('.current-menu-item .sub-menu').addClass('current-submenu');
              $('.current-menu-parent .sub-menu').addClass('current-submenu');

              $('#menu-main-menu .menu-item-has-children > a').on('click', function(e) {
                if(window.innerWidth <= 767 ) {
                  e.preventDefault();
                  var submenu = $(this).next('.sub-menu');
                  submenu.not(':has(\'.item-overview\')').prepend('<li class="menu-item item-overview"><a href="' + $(this).attr('href') + '">Overview</a></li>');

                  $(this).parent('.menu-item-has-children').toggleClass('open');

                  submenu.slideToggle();
                }
              });

              $(window).resize(function() {
                if(window.innerWidth >= 767 ) {
                  $('.menu-item-has-children .item-overview').remove();
                  $('.current-menu-item').removeClass('open');
                  $('.current-menu-parent').removeClass('open');
                  $('.current-submenu').css('display', 'block');
                } else {
                  $('.current-submenu').css('display', 'none');
                }
              });
            */
              /*$(document).on("scroll", function( event ) {

                var windowWidth = window.innerWidth;

                if(windowWidth > 767) {

                  var scrollPos = $(document).scrollTop();
                  var elem = $('.current-submenu');

                  maxWidth = elem.closest('.container').width();
                  maxWidth = maxWidth + 30;
                  left = (windowWidth - maxWidth) / 2;

                  if(scrollPos > 110) {
                    $('.current-submenu').css('position', 'fixed').css('left', left + 'px').css('top', 0);
                  } else {
                    $('.current-submenu').css('position', '').css('left', '').css('top', '110px');
                  }

                }

              });*/

            });


        })(jQuery);

        /* END OLD JS */
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js